import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil';
import Background from '../../components/Background/Background';
import { clinicState } from '../../globalState';
import styles from './Home.module.scss';
import Loader from '../../components/Loader/Loader';
import { LunaJoyFoundationService } from '../../services/LunajoyFoundationService';
import HomePage from '../../components/HomePage/HomePage';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { code } = useParams()
  const [{ clinic, error }, setClinic] = useRecoilState(clinicState)
  document.title = `Lunajoy`

  // multilingual text
  const { t } = useTranslation()
  const errorTitle = t('errorTitle')

  const loadClinic = useCallback(async () => {
    try {
      const clinic = await LunaJoyFoundationService.getClinicByCode(code)
      if (!clinic.typesOfScreen || !clinic.typesOfScreen?.length) {
        clinic.typesOfScreen = ["PHQ9-GAD7"];
        clinic.screeningSlugs = { "phq9-gad7": `${code}-phq9-gad7` };
      }
      setClinic({ clinic: { ...clinic, }, error: null })
      document.title = clinic.name
    } catch (error) {
      console.log(error)
      setClinic({ clinic: null, error: 'Not Found' })
    }
  }, [code])


  useEffect(() => {
    if (code) {
      loadClinic()
    }
  }, [code])

  if (error) return (
    <main>
      <Background clinicDetails={null}>
        <div className={styles.container}>
          <h1 className={styles.screeningHeader}>{errorTitle}</h1>
        </div>
      </Background>
    </main>
  )

  if (code && !clinic) return (
    <main>
      <Background clinicDetails={null}>
        <div className={styles.container}>
          <h1 className={styles.screeningHeader}><Loader /></h1>
        </div>
      </Background>
    </main>
  )

  return (
    <main>
      <HomePage />
    </main>
  )
}

export default Home